import { ROUTES } from 'src/config/routes';

interface OnboardingResumeSubject {
  school_level?: unknown;
  education_level_code?: unknown;
  family_member_type?: unknown;
  firstname?: unknown;
}

export const computeChildOnboardingFallbackRoute = (
  me: OnboardingResumeSubject,
  searchParams: URLSearchParams,
): string => {
  if (me.school_level || me.education_level_code) {
    const params = new URLSearchParams(searchParams);
    params.set('fromParentOnboarding', 'true');
    return `${ROUTES.ONBOARDING_CHILD_DEVICE_SAME.path}?${params.toString()}`;
  }
  if (me.family_member_type) {
    return `${ROUTES.ONBOARDING_CHILD_SCHOOL_GROUP.path}?${searchParams.toString()}`;
  }
  if (me.firstname) {
    return `${ROUTES.ONBOARDING_CHILD_GENDER.path}?${searchParams.toString()}`;
  }
  return `${ROUTES.ONBOARDING_CHILD_FIRSTNAME.path}?${searchParams.toString()}`;
};
